import { useTranslations } from '@npco/common-utils-translations'
import {
  MessageSize,
  MessageWithIcon,
  PageTemplate,
  SIMCard,
} from '@npco/zeller-design-system'

import { useIsMobileResolution } from 'hooks/useIsMobileResolution'
import { EmptyStateCard } from 'components/EmptyStateCard/EmptyStateCard'
import { MobileNavHeader } from 'components/Sidebar/components/MobileNavHeader/MobileNavHeader'

import { HeaderPrimaryRow } from '../components/HeaderPrimaryRow/HeaderPrimaryRow'
import { PurchaseSimButton } from '../components/PurchaseSimButton/PurchaseSimButton'
import { translations } from './SimEmptyPage.i18n'
import * as styled from './SimEmptyPage.styled'

export const SimEmptyPage = () => {
  const isMobile = useIsMobileResolution()
  const t = useTranslations(translations)

  return (
    <PageTemplate
      HeaderPrimaryRow={
        <HeaderPrimaryRow>
          <PurchaseSimButton isFilled />
        </HeaderPrimaryRow>
      }
      HeaderMobileRow={<MobileNavHeader />}
    >
      <styled.Container>
        <MessageWithIcon
          size={MessageSize.LARGE}
          title={t('title')}
          image={<SIMCard size={isMobile ? 'medium' : 'large'} />}
          description={t('description')}
        />
        <EmptyStateCard
          heading={t('cardHeading')}
          valuePoints={[t('point1'), t('point2'), t('point3')]}
        />
      </styled.Container>
    </PageTemplate>
  )
}
